import { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { AIInsightBanner } from "../components/AIInsightBanner";
import { usePeriod } from "../lib/PeriodContext";
import api from "../lib/api";
import { fmtNum, fmtPct } from "../lib/format";

export default function InventoryIntelligence() {
  const { projectsQS } = usePeriod();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/kpi/inventory?${projectsQS.replace(/^&/, "")}`).then((r) => setData(r.data));
  }, [projectsQS]);

  if (!data) return <><Header title="Inventory Intelligence" /><div className="p-6">Loading...</div></>;

  return (
    <>
      <Header title="Inventory Intelligence" subtitle="Absorption · Available · Blocked" />
      <div className="p-3 sm:p-6 md:p-8 max-w-[1600px] mx-auto space-y-5 min-w-0">
        <AIInsightBanner context={{ kpis: { available_units: data.projects.reduce((a, b) => a + b.available, 0), blocked_units: data.projects.reduce((a, b) => a + b.blocked, 0) } }} />

        <div className="bg-white rounded-md border border-slate-200">
          <div className="px-4 py-3 border-b border-slate-200 text-sm font-semibold flex items-center justify-between">
            <span>Stock Status by Project</span>
            <span className="text-[10px] uppercase tracking-wider text-slate-500 font-mono">
              {data.projects.length} active projects with inventory
            </span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-xs" data-testid="inventory-table">
              <thead className="bg-slate-50 text-slate-600">
                <tr>
                  <th className="text-left px-4 py-2">Project</th>
                  <th className="text-right px-4 py-2">Sold</th>
                  <th className="text-right px-4 py-2">Available</th>
                  <th className="text-right px-4 py-2">Blocked</th>
                  <th className="text-right px-4 py-2">Total</th>
                  <th className="text-right px-4 py-2">Absorption</th>
                  <th className="text-left px-4 py-2 w-40">Mix</th>
                </tr>
              </thead>
              <tbody>
                {data.projects.map((r) => {
                  const total = r.total || 1;
                  return (
                    <tr key={r.project_name} className="border-t border-slate-100">
                      <td className="px-4 py-2 truncate max-w-[220px]">{r.project_name}</td>
                      <td className="numeric-cell px-4 py-2">{fmtNum(r.sold)}</td>
                      <td className="numeric-cell px-4 py-2">{fmtNum(r.available)}</td>
                      <td className="numeric-cell px-4 py-2 text-amber-700">{fmtNum(r.blocked)}</td>
                      <td className="numeric-cell px-4 py-2 font-semibold">{fmtNum(r.total)}</td>
                      <td className={`numeric-cell px-4 py-2 font-semibold ${r.absorption_pct >= 70 ? "text-emerald-600" : r.absorption_pct >= 50 ? "text-amber-600" : "text-red-600"}`}>
                        {fmtPct(r.absorption_pct)}
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex h-2 rounded overflow-hidden bg-slate-100">
                          <div style={{ width: `${(r.sold / total) * 100}%`, background: "#0F1D32" }} />
                          <div style={{ width: `${(r.available / total) * 100}%`, background: "#94A3B8" }} />
                          <div style={{ width: `${(r.blocked / total) * 100}%`, background: "#F59E0B" }} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
